import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelPromptTitle: {
        id: 'ml.reinstatement.common.config.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    cancelPrompt: {
        id: 'ml.reinstatement.common.config.Are you sure you want to withdraw this reinstatement?',
        defaultMessage: 'Are you sure you want to withdraw this reinstatement?'
    },
    genericErrorMessage: {
        id: 'ml.reinstatement.common.config.Something went wrong during this process.',
        defaultMessage: 'Something went wrong during this process.'
    },
    genericErrorTitle: {
        id: 'ml.reinstatement.common.config.Error',
        defaultMessage: 'Error'
    },
    withdrawErrorMessage: {
        id: 'ml.reinstatement.common.config.An error occurred while attempting to withdraw the reinstatement',
        defaultMessage: 'An error occurred while attempting to withdraw the reinstatement'
    },
    withdrawErrorTitle: {
        id: 'ml.reinstatement.common.config.Unable to withdraw reinstatement',
        defaultMessage: 'Unable to withdraw reinstatement'
    },
    withdrawing: {
        id: 'ml.reinstatement.common.config.Withdrawing reinstatement...',
        defaultMessage: 'Withdrawing reinstatement...'
    },
    reinstatePolicy: {
        id: 'instatement.wizard.step.Reinstate Policy',
        defaultMessage: 'Reinstate Policy'
    },
    completedChanges: {
        id: 'ml.reinstatement.wizard.step.Completed Changes',
        defaultMessage: 'Completed Changes'
    },
    policyReinstatatementConfirmation: {
        id: 'ml.reinstatement.wizard.step.Policy Reinstatement Confirmation',
        defaultMessage: 'Policy Reinstatement Confirmation'
    },
    creatingReinstatement: {
        id: 'ml.reinstatement.wizard.step.Creating reinstatement...',
        defaultMessage: 'Creating reinstatement...'
    },
});